import { createBrowserClient } from '@supabase/ssr'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('⚠️ 請設定 Supabase 環境變數！請參考 .env.example')
}

// 使用 @supabase/ssr 的 createBrowserClient
// 同 origin 下自動讀取主系統設定的 Supabase auth cookie，共用 session
// token refresh 由主系統的 Supabase session 自動處理
export const supabase = createBrowserClient(supabaseUrl, supabaseAnonKey)
